export default __webpack_public_path__ + "static/media/rectangle-green-icon.88435447.svg";